import $ from 'jquery';
import { __ } from '@wordpress/i18n';
const dsp = (global.dsp = global.dsp || {});

// There's not a great way to access icons from JS.
// This is the output of `{{ theme_icon("loader", {class: "animate-spin showroom-megamenu-model__loader fill-current"}) }}`
const loaderIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="animate-spin trheme-loader showroom-megamenu-model__loader fill-current" fill="currentColor" viewBox="0 0 24 24">
  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
  <path class="opacity-75" fill="#ffffff88" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
</svg>`;

dsp.dealerTools.register('dsp-hover-content-create', function ($trigger, data, $context) {
  const $parent = $trigger.parent();
  let $container = $parent.children('.dropdown-menu').first();

  if ($container.length == 0) {
    $container = $(
      `<div id="dsp-hover-content--${data.key}" class="dsp-hover-content-container dsp-hover-content-container_${data.key}">LOADING</div>`,
    );
    $trigger.after($container);

    $parent.on('mouseenter', () => {
      $container.show();
    });

    $parent.on('mouseleave', () => {
      $container.hide();
    });

    $container.hide();
  } else {
    $container.addClass('dsp-hover-content-container');
    $container.prepend(`<li class="showroom-megamenu-model">
      <span class="showroom-megamenu-model__summary">
        <span class="showroon-megamenu-model__label">
          ${__('Loading', 'oem-theme')}
        </span>
        <span class="showroom-megamenu-model__thumb">
          ${loaderIcon}
        </span>
      </span>
    </li>`);
  }

  data.contentPromise.then((content) => {
    $container.html(content);
    data.activateHoverContent($container);
  });

});
